'use client';

import type { RichtextBlock } from '@impact/types';
import { RichtextTiptap } from '@/components/page-editor/v2/canvas/RichtextTiptap';

interface RichtextBlockRendererProps {
  block: RichtextBlock;
  editing?: boolean;
}

export function RichtextBlockRenderer({ block, editing }: RichtextBlockRendererProps) {
  if (editing) {
    return (
      <RichtextTiptap blockId={block.id} initialHtml={block.data.html ?? ''} path="data.html" />
    );
  }

  if (!block.data.html) {
    return null;
  }

  return (
    <div
      className="prose prose-lg max-w-none prose-headings:font-bold prose-headings:text-foreground prose-p:text-muted-foreground prose-a:text-primary prose-a:no-underline hover:prose-a:underline prose-strong:text-foreground prose-ul:text-muted-foreground prose-ol:text-muted-foreground prose-li:marker:text-primary [&>p]:mb-4 [&>h1]:mt-8 [&>h1]:mb-4 [&>h2]:mt-8 [&>h2]:mb-4 [&>h3]:mt-6 [&>h3]:mb-3 [&>h4]:mt-6 [&>h4]:mb-3 [&>ul]:my-4 [&>ol]:my-4 [&_li]:mb-2"
      dangerouslySetInnerHTML={{ __html: block.data.html }}
    />
  );
}
